const FallBackRoute = (): React.JSX.Element => (
  <div>
    <h1>404</h1>
    <h5>Página no encontrada!</h5>
  </div>
);

export default FallBackRoute;
